// src/components/captures/CaptureFilterBar.tsx
import React from 'react';
import { Archive } from '../common/icons';
import { useOnboarding, TipTooltip } from '../../features/onboarding';
import { eventBus, EVENTS } from '../../utils/eventBus';

interface CaptureFilterBarProps {
  // Inbox 篩選
  isInboxActive?: boolean;
  onInboxToggle?: (active: boolean) => void;
  // Lesson 模式下抑制 Tips，避免干擾引導流程
  isLessonMode?: boolean;
}

const CaptureFilterBar: React.FC<CaptureFilterBarProps> = ({
  isInboxActive = false,
  onInboxToggle,
  isLessonMode = false,
}) => {
  const { getActiveTipForPage, dismissAndShowNext } = useOnboarding();
  const activeTip = isLessonMode ? null : getActiveTipForPage('captures');

  const handleInboxClick = () => {
    // 發佈 UI 事件用於 Tip 自動標記
    eventBus.publish(EVENTS.UI.INBOX_FILTER_CLICKED);
    if (onInboxToggle) {
      onInboxToggle(!isInboxActive);
    }
  };

  return (
    <div className="subheader-wrapper">
      <div className="subheader-container">
        <div className="flex items-center">
          {/* Inbox 篩選按鈕 */}
          <div className="relative">
            <button
              onClick={handleInboxClick}
              className={`inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg border transition-all duration-200 ${
                isInboxActive
                  ? 'bg-sky-50 border-sky-500 text-sky-600'
                  : 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300'
              }`}
            >
              <Archive className="w-4 h-4" />
              <span>Inbox</span>
            </button>
            {/* Tip: Inbox 篩選 */}
            {activeTip === 'captures-inbox-filter' && (
              <TipTooltip
                tipId="captures-inbox-filter"
                onClose={() => dismissAndShowNext('captures-inbox-filter', 'captures')}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaptureFilterBar;